var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _rect, _path185, _path186, _path187, _path188, _path189, _path190, _g, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _text, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _circle, _path207, _path208, _path209, _circle2, _circle3, _path210, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAraclar10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 437.62 270.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);filter:url(#luminosity-noclip-2);}.cls-2{mix-blend-mode:multiply;fill:url(#linear-gradient);}.cls-3{fill:#010101;}.cls-4{fill:#3e9bd5;}.cls-5{fill:none;}.cls-39,.cls-6{fill:#ffc50f;}.cls-6{opacity:0.42;}.cls-7{fill:#333;}.cls-8{fill:#af1f23;}.cls-9{fill:#db1f26;}.cls-10{opacity:0.19;fill:url(#linear-gradient-2);}.cls-11{fill:url(#linear-gradient-3);}.cls-12{fill:url(#linear-gradient-4);}.cls-13{fill:url(#radial-gradient);}.cls-14{fill:url(#radial-gradient-2);}.cls-15{fill:url(#radial-gradient-3);}.cls-16{fill:url(#radial-gradient-4);}.cls-17{fill:url(#radial-gradient-5);}.cls-18{fill:url(#radial-gradient-6);}.cls-19{fill:url(#radial-gradient-7);}.cls-20{fill:url(#radial-gradient-8);}.cls-21{fill:url(#radial-gradient-9);}.cls-22{fill:url(#radial-gradient-10);}.cls-23{fill:url(#radial-gradient-11);}.cls-24{fill:url(#radial-gradient-12);}.cls-25{fill:url(#radial-gradient-13);}.cls-26,.cls-33,.cls-42,.cls-46,.cls-52{fill:#fff;}.cls-26{opacity:0.12;}.cls-27{fill:url(#linear-gradient-5);}.cls-28{fill:url(#linear-gradient-6);}.cls-29{fill:url(#linear-gradient-7);}.cls-30{fill:url(#linear-gradient-8);}.cls-31{fill:url(#linear-gradient-9);}.cls-32{fill:url(#radial-gradient-14);}.cls-33{opacity:0.15;}.cls-34{fill:url(#linear-gradient-10);}.cls-35,.cls-44,.cls-45{fill:#e6e6e5;}.cls-36{fill:#b4b4b4;}.cls-37{fill:#989898;}.cls-38{fill:#818181;}.cls-40{mask:url(#mask-2);}.cls-41{fill:url(#linear-gradient-11);}.cls-43{fill:url(#linear-gradient-12);}.cls-44{opacity:0.16;}.cls-45{opacity:0.17;}.cls-46{opacity:0.13;}.cls-47{font-size:21.78px;letter-spacing:-0.14em;}.cls-47,.cls-52{font-family:Biko-Bold, Biko;font-weight:700;}.cls-48{letter-spacing:-0.06em;}.cls-49{letter-spacing:-0.1em;}.cls-50{letter-spacing:-0.08em;}.cls-51{fill:#231f20;}.cls-52{font-size:22.12px;letter-spacing:-0.08em;}.cls-53{filter:url(#luminosity-noclip);}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 380.46,
    y: -10450.47,
    width: 33.38,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 380.46,
    y: -10450.47,
    width: 33.38,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 8627.06,
    y1: 144.36,
    x2: 8635.49,
    y2: 166.32,
    gradientTransform: "matrix(-0.42, 0, 0, 1, 4014.01, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ccc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 8927.58,
    y1: 54.51,
    x2: 9035.29,
    y2: 182.88,
    gradientTransform: "matrix(-0.42, 0, 0, 1, 4014.01, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#e6e6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#e6e6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#4e4e4e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 9186.39,
    y1: 164.51,
    x2: 9186.52,
    y2: 171.89,
    gradientTransform: "matrix(-0.42, 0, 0, 1, 4014.01, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 8992.07,
    y1: 165.43,
    x2: 8992.22,
    y2: 173.96,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 5102.21,
    cy: 538.14,
    r: 34.11,
    gradientTransform: "matrix(-0.98, 0, 0, 1, 5374.36, -330.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#30302f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#30302f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#1f1f1f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 5101.78,
    cy: 537.8,
    r: 23.82,
    gradientTransform: "matrix(-0.98, 0, 0, 1, 5374.36, -330.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#888788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#888788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#888788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 4960.03,
    cy: 308.16,
    r: 2.21,
    gradientTransform: "matrix(-0.98, 0.01, 0.01, 1, 5232.71, -178.78)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 4966.99,
    cy: 308.16,
    r: 2.21,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 4960.03,
    cy: 315.08,
    r: 2.21,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 4966.98,
    cy: 315.08,
    r: 2.21,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 5372.05,
    cy: 538.43,
    r: 34.11,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 5371.62,
    cy: 538.1,
    r: 23.82,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 5229.85,
    cy: 304.49,
    r: 2.21,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 5236.8,
    cy: 304.49,
    r: 2.21,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 5229.85,
    cy: 311.41,
    r: 2.21,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 5236.8,
    cy: 311.41,
    r: 2.21,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 5090.48,
    cy: 200.96,
    r: 48.31,
    gradientTransform: "matrix(-0.98, 0, 0, 1, 5361.56, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e4e4e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 8606.54,
    y1: 194.9,
    x2: 8606.54,
    y2: 204.09,
    gradientTransform: "matrix(-0.42, 0, 0, 1, 4014.01, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 8624.67,
    y1: 204.09,
    x2: 8624.67,
    y2: 210.87,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 8612.2,
    y1: 172.74,
    x2: 8612.2,
    y2: 194.9,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 8620.52,
    y1: 167.56,
    x2: 8620.52,
    y2: 172.79,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 9507.49,
    y1: 170.67,
    x2: 9507.49,
    y2: 202.74,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 5359.6,
    cy: 195.87,
    r: 48.29,
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 8845,
    y1: 126.79,
    x2: 8883.7,
    y2: 126.79,
    gradientTransform: "matrix(0.42, 0, 0, -1, -3413.87, 253.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e4e4e"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 380.46,
    y: 145.83,
    width: 33.38,
    height: 21.73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 380.46,
    y: 145.83,
    width: 33.38,
    height: 21.73,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M380.54,151.07c-1.59-6.26,20-5.17,20-5.17l.11,0c7,3.21,12.71,20.06,13.21,21.55l-6.72.06C406.38,167.75,382.13,157.3,380.54,151.07Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 8627.06,
    y1: 144.36,
    x2: 8635.49,
    y2: 166.32,
    gradientTransform: "matrix(-0.42, 0, 0, 1, 4014.01, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 9062.55,
    y1: 200.07,
    x2: 9062.72,
    y2: 209.83,
    gradientTransform: "matrix(-0.42, 0, 0, 1, 4014.01, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#e6e6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33,69A15.16,15.16,0,0,1,46.14,56.8c75-1.62,172.37,3.23,188.27,4.84a62.84,62.84,0,0,1,27.31,9.69c20.81,14.14,58.85,49.94,58.85,49.94l6.23-1.21,2.65,5.52s6.1-.27,8.75,1.35a22.35,22.35,0,0,0,4.37,2.15c13.52,1.89,50.77,13.46,58.06,16.83s13.25,21.67,13.25,21.67,2.55,1.38,4.54,2.59,1.79,2.62,1.79,2.62c2.78,1.62,2.78,2.83,2.78,2.83,0,14.44-3,19.28-3,19.28-4.47,0-6.13,2.53-6.13,2.53a13.85,13.85,0,0,1-9.08,6.66c-1.09,7.57-18.89,8.58-18.89,8.58l.9-5.95-75.75-1-.5,3.73-185.49-3.23a4,4,0,0,1-1.89-2.52l-4.58-1.92-65.21-3.43L48,202.68l-15.6-.91c-6.76,0-6.76-23-6.76-23l-.8-10C21.08,139.78,30.3,80.62,33,69Zm264.94,52.61C287.7,112,268.5,94.08,261.8,88.72a44.06,44.06,0,0,0-24.45-10.1l-26.07-2s-5.92-1.22-5.49,5l.13,28.6a9.66,9.66,0,0,1,7-.64c4.08,1.09,9.72,13.85,11.72,18.68,15.09,1.5,36.32,3.59,52.15,5.05l10.89-13.66c3.6-.64,3,2.69,3,2.69l-9.14,11.41c8.07.73,14.11,1.23,16.14,1.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.64,165.73c2.49,0,2.09-3.74,2.09-3.74s.4-25,.4-28.16a3.64,3.64,0,0,0-2.59-3.74l-3.65-.34C26.82,103.62,31.24,76.49,33,69A15.16,15.16,0,0,1,46.14,56.8c75-1.62,172.37,3.23,188.27,4.84a62.84,62.84,0,0,1,27.31,9.69c20.81,14.14,58.85,49.94,58.85,49.94l.19,0c1.89,4.37,9.78,6.73,9.78,6.73,5.11,1.47,7.15.15,7.94-.88a22.16,22.16,0,0,0,4.09,2C356,131,393,142.44,400.52,145.86c0,0,6,22.21,6.6,23.69a87.29,87.29,0,0,1-20.28,1.26c-2.78-4.58-26.24-29.21-57.39-13.6a48.48,48.48,0,0,0-21.58,21.23l.49-39,5.78.17s10.34,1.11,2-8.48c0,0-3-2.86-7.58-7.17l0-1.71a30,30,0,0,0-9.35-12.93L267,81.63S257.28,73,245.15,70.32c0,0-38.77-3.83-46.52-3.83,0,0-4.77-1.21-4.77,4.44v94.78l-54.48-1a3,3,0,0,0-.11,6.06l54.59.95v24.56a5.74,5.74,0,0,0-.11,2.9L133,198c-1.33-10.13-5.24-26.87-16.81-38.62-17.63-17.9-45.06-12.36-54-6.81-9.76,6.05-16.92,13.81-22.09,29l-14.44-1.35v-1.48l-.8-10c-.13-1-.24-2-.34-3.06Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M415,167c-.38.18-.77.35-1.17.52a.33.33,0,0,0,0-.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M407.21,169.79l-.09-.24c.76-.15,1.51-.33,2.25-.52Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M330.54,128s-7.89-2.36-9.78-6.73l6-1.18,2.65,5.52s6.1-.27,8.75,1.35l.28.16C337.69,128.12,335.65,129.44,330.54,128Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M31.13,133.83c0,3.13-.4,28.16-.4,28.16s.4,3.74-2.09,3.74H24.52c-.94-10-.6-22.86.37-36l3.65.34A3.64,3.64,0,0,1,31.13,133.83Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M30.13,135.84c0,2.68-.34,24.09-.34,24.09s.34,3.2-1.79,3.2H24.4c-.8-8.83-.43-19.56.4-30.77l3.12.28A3.11,3.11,0,0,1,30.13,135.84Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M413.84,167.46a.33.33,0,0,1,0,.1,33.87,33.87,0,0,1-4.5,1.47Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M299.22,170.58a3,3,0,0,1-3,3l-102.32-1.79-54.59-.95a3,3,0,0,1,.11-6.06l54.48,1,102.43,1.79A3,3,0,0,1,299.22,170.58Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M264.34,134.13c-3.78-3-9.94-3-9.94-3l-47.82-1.72s-4.27-44.72-4.77-51.89,6.36-5.75,6.36-5.75l30.22,2.32a51,51,0,0,1,28.33,11.71c7.77,6.21,30,27,41.83,38.16,4.57,4.31,7.58,7.17,7.58,7.17,8.35,9.59-2,8.48-2,8.48l-5.78-.17c-10.13-.31-30.42-.94-34.78-1.24C267.72,137.76,268.11,137.16,264.34,134.13Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.05,129.38s94,9.5,105.91,10l-.48,39a64.63,64.63,0,0,0-6.81,24.82L198,201.37c-1.69,0-2.86-.45-3.48-1.34-1-1.43-.33-3.56-.33-3.58l0-.13V70.93a4.24,4.24,0,0,1,1.27-3.5,3.79,3.79,0,0,1,3-.55h.1c7.64,0,46.09,3.8,46.48,3.84,11.85,2.56,21.55,11.12,21.65,11.2L299,109.6a30,30,0,0,1,9.22,12.68l0,1.28c-11.9-11.21-33.75-31.65-41.44-37.79a51,51,0,0,0-28.33-11.71l-30.22-2.32s-6.86-1.42-6.36,5.75Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M201.85,129.63l-.23-51.9C201.12,70.57,208,72,208,72L238.2,74.3A51.14,51.14,0,0,1,266.53,86c7.77,6.21,30,27,41.83,38.17l-.19,15.47C298,139.34,201.85,129.63,201.85,129.63Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.13,131.1c8.35,9.59-2,8.48-2,8.48l-5.78-.17.19-15.48C313.12,128.24,316.13,131.1,316.13,131.1Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M139.27,170.81a3,3,0,0,1,.11-6.06l54.48,1v6Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M299.22,170.58a3,3,0,0,1-3,3l-102.32-1.79v-6l102.43,1.79A3,3,0,0,1,299.22,170.58Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M333.12,174.42l2.19-1.27-1-1.85-2.19,1.26Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M330.31,176.4l2.05-1.49-1.22-1.73-2.05,1.49Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M327.74,178.67l1.88-1.71-1.4-1.59-1.88,1.71Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M325.42,181.21l1.69-1.91-1.56-1.42-1.68,1.91Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M323.39,184l1.47-2.08-1.7-1.24-1.47,2.07Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M321.65,187l1.25-2.22-1.82-1.05-1.25,2.22Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M320.26,190.15l1-2.35-1.92-.85-1,2.35Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M319.2,193.45l.74-2.45-2-.63-.75,2.45Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M318.49,196.85l.48-2.51-2.05-.41-.49,2.51Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M318.14,200.32l.22-2.55-2.09-.19-.21,2.55Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M318.17,203.77l-.06-2.56-2.09,0,.05,2.56Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M318.56,207.22l-.32-2.54-2.08.28.33,2.54Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M319.32,210.6l-.59-2.49-2,.5.6,2.49Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M320.44,213.88l-.86-2.41-2,.72.86,2.41Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M321.9,217l-1.11-2.3-1.88.93L320,218Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M323.67,220l-1.34-2.17L320.55,219l1.34,2.17Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M325.76,222.76l-1.56-2-1.64,1.32,1.56,2Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M328.1,225.25l-1.77-1.83-1.49,1.49,1.77,1.83Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M330.73,227.49l-2-1.62-1.33,1.65,2,1.62Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M333.56,229.42,331.45,228l-1.15,1.78,2.12,1.4Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M336.58,231l-2.25-1.16-.95,1.89,2.25,1.16Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M339.77,232.31l-2.36-.9-.74,2,2.36.91Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M343,233.23l-2.44-.65-.53,2.06,2.44.65Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M346.42,233.79l-2.49-.38-.31,2.11,2.49.38Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M349.86,234l-2.53-.1-.08,2.12,2.52.1Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M353.26,233.79l-2.52.18.14,2.12,2.52-.18Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M356.63,233.23l-2.49.45.37,2.09,2.48-.45Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M359.91,232.3l-2.42.72.59,2,2.42-.72Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M363.1,231l-2.32,1,.8,2,2.33-1Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M366.12,229.39l-2.22,1.23,1,1.86,2.21-1.23Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M369,227.44l-2.07,1.46,1.2,1.75,2.07-1.46Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M371.57,225.2l-1.9,1.68,1.37,1.61,1.9-1.68Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M373.92,222.69l-1.71,1.88,1.54,1.45,1.71-1.88Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M376,220,374.48,222l1.68,1.26,1.51-2.05Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M377.76,217l-1.28,2.21,1.81,1.07,1.28-2.21Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M379.21,213.82l-1,2.34,1.91.87,1-2.34Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M380.31,210.55l-.78,2.44,2,.66.78-2.44Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M381.07,207.16l-.53,2.51,2,.44.53-2.51Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M381.46,203.73l-.26,2.55,2.09.21.25-2.55Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M381.48,200.23l0,2.56h2.1l0-2.56Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M381.14,196.8l.29,2.55,2.08-.25-.29-2.54Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M380.42,193.39l.57,2.5,2-.47-.57-2.5Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M379.36,190.11l.82,2.42,2-.7-.82-2.42Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M377.94,187l1.08,2.31,1.89-.9L379.84,186Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M376.21,184l1.31,2.19,1.79-1.11L378,182.85Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M374.17,181.17l1.53,2,1.66-1.29-1.53-2Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M371.85,178.62l1.74,1.86L375.1,179l-1.74-1.86Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M369.28,176.36l1.93,1.66,1.35-1.63-1.93-1.65Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M366.46,174.38l2.09,1.43,1.17-1.77-2.1-1.43Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M363.46,172.72l2.23,1.19,1-1.88-2.23-1.19Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M360.29,171.4l2.34.94.77-2-2.34-.94Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M357,170.43l2.43.68.56-2.05-2.43-.68Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M353.65,169.82l2.49.42.34-2.1-2.49-.41Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M350.25,169.59l2.52.14.11-2.13-2.52-.14Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M346.83,169.72l2.51-.13-.11-2.13-2.52.14Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M343.45,170.24l2.49-.42-.34-2.1-2.48.42Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.14,171.12l2.43-.69-.56-2.05-2.43.69Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M337,172.35l2.34-.94-.77-2-2.35.95Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M316.26,201.8c0,18.84,15,34.12,33.55,34.15s33.61-15.24,33.63-34.08-15-34.13-33.56-34.15S316.28,183,316.26,201.8Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M326.82,201.47a23.46,23.46,0,1,0,23.48-23.79A23.65,23.65,0,0,0,326.82,201.47Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M347.51,183.14a2.28,2.28,0,0,0,.7,1.64,2.26,2.26,0,0,0,3.24-.05,2.34,2.34,0,0,0-.05-3.29,2.18,2.18,0,0,0-1.63-.66,2.15,2.15,0,0,0-1.61.71A2.29,2.29,0,0,0,347.51,183.14Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.76,185.43a2.28,2.28,0,0,0,3,1.26,2.36,2.36,0,0,0,1.24-3.05,2.26,2.26,0,0,0-1.24-1.26,2.2,2.2,0,0,0-1.76,0,2.17,2.17,0,0,0-1.24,1.26A2.25,2.25,0,0,0,340.76,185.43Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M335.37,190.15a2.15,2.15,0,0,0,1.61.69,2.17,2.17,0,0,0,1.63-.67,2.33,2.33,0,0,0-1.6-4,2.22,2.22,0,0,0-1.63.68,2.24,2.24,0,0,0-.68,1.64A2.27,2.27,0,0,0,335.37,190.15Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M332.11,196.6a2.18,2.18,0,0,0,1.75,0,2.23,2.23,0,0,0,1.26-1.24,2.36,2.36,0,0,0,0-1.79,2.26,2.26,0,0,0-1.23-1.27,2.16,2.16,0,0,0-1.76,0,2.35,2.35,0,0,0-1.27,3A2.26,2.26,0,0,0,332.11,196.6Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M331.5,203.82a2.19,2.19,0,0,0,1.63-.66,2.26,2.26,0,0,0,.7-1.63,2.29,2.29,0,0,0-.65-1.66,2.19,2.19,0,0,0-1.61-.71,2.22,2.22,0,0,0-1.63.65,2.3,2.3,0,0,0-.7,1.64,2.24,2.24,0,0,0,.65,1.66A2.19,2.19,0,0,0,331.5,203.82Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M333.6,210.74a2.34,2.34,0,0,0,.1-4.3,2.16,2.16,0,0,0-1.76,0,2.23,2.23,0,0,0-1.27,1.23,2.31,2.31,0,0,0,0,1.79,2.23,2.23,0,0,0,1.22,1.28A2.18,2.18,0,0,0,333.6,210.74Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M338.14,216.35a2.26,2.26,0,0,0,.72-1.63,2.23,2.23,0,0,0-.63-1.66A2.27,2.27,0,0,0,335,213a2.3,2.3,0,0,0-.72,1.63,2.32,2.32,0,0,0,.63,1.67,2.26,2.26,0,0,0,3.24.09Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M344.38,219.79a2.32,2.32,0,0,0-1.13-3.08,2.14,2.14,0,0,0-1.75-.06,2.2,2.2,0,0,0-1.29,1.21,2.29,2.29,0,0,0-.06,1.78,2.25,2.25,0,0,0,1.2,1.31,2.14,2.14,0,0,0,1.75.06A2.23,2.23,0,0,0,344.38,219.79Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M351.48,220.59a2.31,2.31,0,0,0-.6-1.67,2.28,2.28,0,0,0-3.25-.14,2.32,2.32,0,0,0-.74,1.62,2.28,2.28,0,0,0,.61,1.67,2.17,2.17,0,0,0,1.6.75,2.14,2.14,0,0,0,1.64-.61A2.28,2.28,0,0,0,351.48,220.59Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M358.36,218.61a2.26,2.26,0,0,0-1.18-1.32,2.18,2.18,0,0,0-1.75-.08,2.33,2.33,0,0,0-1.38,3,2.28,2.28,0,0,0,2.94,1.4,2.23,2.23,0,0,0,1.3-1.2A2.29,2.29,0,0,0,358.36,218.61Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364,214.14a2.21,2.21,0,0,0-1.59-.76,2.15,2.15,0,0,0-1.65.59,2.35,2.35,0,0,0-.17,3.29,2.17,2.17,0,0,0,1.59.77,2.2,2.2,0,0,0,1.65-.6,2.28,2.28,0,0,0,.76-1.61A2.3,2.3,0,0,0,364,214.14Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M367.52,207.87a2.14,2.14,0,0,0-1.75-.11,2.24,2.24,0,0,0-1.31,1.18,2.29,2.29,0,0,0-.1,1.78,2.29,2.29,0,1,0,4.33-1.52A2.23,2.23,0,0,0,367.52,207.87Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M368.47,200.7a2.34,2.34,0,0,0-1.87,3.86,2.27,2.27,0,0,0,3.24.22,2.37,2.37,0,0,0,.21-3.29A2.26,2.26,0,0,0,368.47,200.7Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M366.69,193.68a2.2,2.2,0,0,0-1.32,1.16,2.34,2.34,0,0,0,1,3.13,2.18,2.18,0,0,0,1.75.13,2.25,2.25,0,0,0,1.33-1.18,2.29,2.29,0,0,0,.12-1.78,2.22,2.22,0,0,0-1.15-1.34A2.14,2.14,0,0,0,366.69,193.68Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M362.43,187.86a2.24,2.24,0,0,0-.8,1.59,2.27,2.27,0,0,0,.55,1.69,2.27,2.27,0,0,0,3.23.26,2.24,2.24,0,0,0,.8-1.6,2.29,2.29,0,0,0-.55-1.69,2.25,2.25,0,0,0-3.23-.25Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M356.33,184.11a2.23,2.23,0,0,0-.14,1.77,2.2,2.2,0,0,0,1.13,1.36,2.14,2.14,0,0,0,1.75.15,2.18,2.18,0,0,0,1.34-1.15,2.34,2.34,0,0,0-1-3.14,2.18,2.18,0,0,0-1.75-.14A2.21,2.21,0,0,0,356.33,184.11Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M353.15,200.33h0a2.2,2.2,0,0,0,2.14-2.24h0a2.19,2.19,0,0,0-2.2-2.18h0a2.21,2.21,0,0,0-2.15,2.24h0A2.21,2.21,0,0,0,353.15,200.33Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M346.3,200.42h0a2.21,2.21,0,0,0,2.15-2.24h0a2.21,2.21,0,0,0-2.21-2.18h0a2.2,2.2,0,0,0-2.14,2.24h0A2.2,2.2,0,0,0,346.3,200.42Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M353.24,207.24h0a2.21,2.21,0,0,0,2.15-2.24h0a2.2,2.2,0,0,0-2.21-2.17h0a2.19,2.19,0,0,0-2.14,2.23h0A2.2,2.2,0,0,0,353.24,207.24Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M346.4,207.34h0a2.2,2.2,0,0,0,2.14-2.24h0a2.2,2.2,0,0,0-2.2-2.18h0a2.21,2.21,0,0,0-2.15,2.24h0A2.21,2.21,0,0,0,346.4,207.34Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.42,174.42l2.19-1.27-1-1.85-2.19,1.26Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.61,176.4l2-1.49-1.22-1.73-2,1.49Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62,178.67,63.92,177l-1.4-1.59-1.88,1.71Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59.72,181.21l1.69-1.91-1.55-1.42-1.69,1.91Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.69,184l1.47-2.08-1.7-1.24L56,182.75Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56,187l1.24-2.22-1.82-1.05-1.24,2.22Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.56,190.15l1-2.35L53.64,187l-1,2.35Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.5,193.45l.75-2.45-2-.63-.75,2.45Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.79,196.85l.49-2.51-2.06-.41-.49,2.51Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.44,200.32l.22-2.55-2.08-.19-.22,2.55Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.47,203.77l0-2.56-2.1,0,.06,2.56Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.86,207.22l-.32-2.54-2.08.28.33,2.54Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.62,210.6,53,208.11l-2,.5.6,2.49Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.74,213.88l-.86-2.41-2,.72.86,2.41Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.2,217l-1.11-2.3-1.88.93,1.11,2.3Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58,220l-1.34-2.17L54.86,219l1.34,2.17Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.06,222.76l-1.56-2-1.64,1.32,1.56,2Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62.4,225.25l-1.77-1.83-1.49,1.49,1.77,1.83Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65,227.49l-2-1.62-1.33,1.65,2,1.62Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.86,229.42,65.75,228l-1.15,1.78,2.12,1.4Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.88,231l-2.25-1.16-.94,1.89,2.25,1.16Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.07,232.31l-2.36-.9-.74,2,2.36.91Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.34,233.23l-2.44-.65-.53,2.06,2.45.65Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.73,233.79l-2.5-.38-.31,2.11,2.5.38Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.16,234l-2.52-.1L81.55,236l2.52.1Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.56,233.79,85,234l.15,2.12,2.51-.18Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.93,233.23l-2.48.45.36,2.09,2.49-.45Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.21,232.3l-2.42.72.59,2,2.42-.72Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.41,231l-2.33,1,.8,2,2.33-1Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.42,229.39l-2.21,1.23,1,1.86,2.21-1.23Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.26,227.44l-2.07,1.46,1.2,1.75,2.07-1.46Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.87,225.2l-1.9,1.68,1.37,1.61,1.91-1.68Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.22,222.69l-1.71,1.88,1.54,1.45,1.71-1.88Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.29,220l-1.5,2.06,1.68,1.26,1.5-2.05Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.06,217l-1.27,2.21,1.8,1.07,1.28-2.21Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.51,213.82l-1,2.34,1.91.87,1-2.34Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.61,210.55l-.78,2.44,2,.66.78-2.44Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.37,207.16l-.52,2.51,2.05.44.52-2.51Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.76,203.73l-.26,2.55,2.09.21.25-2.55Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.78,200.23l0,2.56h2.1l0-2.56Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.44,196.8l.29,2.55,2.08-.25-.29-2.54Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.72,193.39l.57,2.5,2-.47-.56-2.5Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.66,190.11l.82,2.42,2-.7-.82-2.42Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.24,187l1.08,2.31,1.89-.9L114.14,186Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.51,184l1.31,2.19,1.79-1.11-1.31-2.19Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.47,181.17l1.53,2,1.67-1.29-1.54-2Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.15,178.62l1.74,1.86L109.4,179l-1.74-1.86Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.58,176.36l1.93,1.66,1.35-1.63-1.93-1.65Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.76,174.38l2.09,1.43L104,174l-2.09-1.43Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.76,172.72l2.23,1.19,1-1.88-2.23-1.19Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.59,171.4l2.34.94.77-2-2.34-.94Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91.3,170.43l2.44.68.55-2.05-2.43-.68Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88,169.82l2.5.42.33-2.1-2.49-.41Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.55,169.59l2.52.14.12-2.13-2.52-.14Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.13,169.72l2.51-.13-.11-2.13L81,167.6Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.76,170.24l2.49-.42-.34-2.1-2.49.42Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.44,171.12l2.43-.69-.56-2.05-2.43.69Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71.26,172.35l2.34-.94-.77-2-2.34.95Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M50.56,201.8c0,18.84,15,34.12,33.55,34.15s33.61-15.24,33.63-34.08-15-34.13-33.55-34.15S50.58,183,50.56,201.8Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M61.12,201.47A23.46,23.46,0,1,0,84.6,177.68,23.65,23.65,0,0,0,61.12,201.47Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.82,183.14a2.27,2.27,0,0,0,.69,1.64,2.31,2.31,0,0,0,3.19-3.34,2.26,2.26,0,0,0-3.24.05A2.25,2.25,0,0,0,81.82,183.14Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.06,185.43a2.2,2.2,0,0,0,1.24,1.26,2.18,2.18,0,0,0,1.75,0,2.32,2.32,0,1,0-3-3A2.29,2.29,0,0,0,75.06,185.43Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.67,190.15a2.15,2.15,0,0,0,1.61.69,2.17,2.17,0,0,0,1.63-.67,2.31,2.31,0,1,0-3.23-3.31,2.34,2.34,0,0,0,0,3.29Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.41,196.6a2.18,2.18,0,0,0,1.75,0,2.23,2.23,0,0,0,1.26-1.24,2.31,2.31,0,0,0,0-1.79,2.23,2.23,0,0,0-1.23-1.27,2.14,2.14,0,0,0-1.75,0,2.21,2.21,0,0,0-1.26,1.25,2.33,2.33,0,0,0,1.21,3Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.8,203.82a2.19,2.19,0,0,0,1.63-.66,2.26,2.26,0,0,0,.7-1.63,2.33,2.33,0,0,0-.64-1.66,2.2,2.2,0,0,0-1.61-.71,2.23,2.23,0,0,0-1.64.65,2.3,2.3,0,0,0-.7,1.64,2.28,2.28,0,0,0,.65,1.66A2.19,2.19,0,0,0,65.8,203.82Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.9,210.74a2.2,2.2,0,0,0,1.27-1.23A2.35,2.35,0,0,0,68,206.44a2.16,2.16,0,0,0-1.76,0A2.23,2.23,0,0,0,65,207.63a2.36,2.36,0,0,0,0,1.79,2.23,2.23,0,0,0,1.22,1.28A2.18,2.18,0,0,0,67.9,210.74Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.44,216.35a2.36,2.36,0,0,0,.1-3.29,2.28,2.28,0,0,0-3.25-.1,2.25,2.25,0,0,0-.71,1.63,2.27,2.27,0,0,0,.62,1.67,2.26,2.26,0,0,0,3.24.09Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.68,219.79a2.33,2.33,0,0,0-1.12-3.08,2.16,2.16,0,0,0-1.76-.06,2.22,2.22,0,0,0-1.29,1.21,2.29,2.29,0,0,0-.06,1.78,2.25,2.25,0,0,0,1.2,1.31,2.14,2.14,0,0,0,1.75.06A2.23,2.23,0,0,0,78.68,219.79Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.78,220.59a2.31,2.31,0,0,0-.6-1.67,2.23,2.23,0,0,0-1.6-.75,2.17,2.17,0,0,0-1.64.61,2.36,2.36,0,0,0-.14,3.29,2.17,2.17,0,0,0,1.6.75,2.14,2.14,0,0,0,1.64-.61A2.28,2.28,0,0,0,85.78,220.59Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.66,218.61a2.23,2.23,0,0,0-1.18-1.32,2.18,2.18,0,0,0-1.75-.08,2.34,2.34,0,0,0-.2,4.3,2.2,2.2,0,0,0,1.76.08,2.23,2.23,0,0,0,1.3-1.2A2.29,2.29,0,0,0,92.66,218.61Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.28,214.14a2.21,2.21,0,0,0-1.58-.76A2.16,2.16,0,0,0,95,214a2.37,2.37,0,0,0-.17,3.29,2.17,2.17,0,0,0,1.59.77,2.32,2.32,0,0,0,2.41-2.21A2.3,2.3,0,0,0,98.28,214.14Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.83,207.87a2.16,2.16,0,0,0-1.76-.11,2.24,2.24,0,0,0-1.31,1.18,2.29,2.29,0,0,0-.1,1.78,2.24,2.24,0,0,0,1.16,1.34,2.28,2.28,0,0,0,3.07-1.09,2.34,2.34,0,0,0-1.06-3.1Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.77,200.7a2.22,2.22,0,0,0-1.66.58,2.36,2.36,0,0,0-.21,3.28,2.28,2.28,0,0,0,3.24.22,2.25,2.25,0,0,0,.77-1.61,2.2,2.2,0,0,0-.56-1.68A2.26,2.26,0,0,0,102.77,200.7Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101,193.68a2.2,2.2,0,0,0-1.32,1.16,2.34,2.34,0,0,0,1,3.13,2.18,2.18,0,0,0,1.75.13,2.22,2.22,0,0,0,1.33-1.18,2.29,2.29,0,0,0,.12-1.78,2.22,2.22,0,0,0-1.15-1.34A2.14,2.14,0,0,0,101,193.68Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.73,187.86a2.28,2.28,0,0,0-.8,1.59,2.31,2.31,0,0,0,.55,1.69,2.28,2.28,0,0,0,3.24.26,2.27,2.27,0,0,0,.79-1.6,2.29,2.29,0,0,0-.55-1.69,2.25,2.25,0,0,0-3.23-.25Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.63,184.11a2.32,2.32,0,0,0-.14,1.77,2.2,2.2,0,0,0,1.13,1.36,2.28,2.28,0,0,0,3.09-1,2.34,2.34,0,0,0-1-3.14A2.18,2.18,0,0,0,92,183,2.24,2.24,0,0,0,90.63,184.11Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M87.45,200.33h0a2.2,2.2,0,0,0,2.14-2.24h0a2.18,2.18,0,0,0-2.2-2.18h0a2.19,2.19,0,0,0-2.14,2.24h0A2.2,2.2,0,0,0,87.45,200.33Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M80.6,200.42h0a2.21,2.21,0,0,0,2.15-2.24h0a2.21,2.21,0,0,0-2.2-2.18h0a2.21,2.21,0,0,0-2.15,2.24h0A2.2,2.2,0,0,0,80.6,200.42Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M87.54,207.24h0A2.2,2.2,0,0,0,89.69,205h0a2.2,2.2,0,0,0-2.21-2.17h0a2.19,2.19,0,0,0-2.14,2.23h0A2.2,2.2,0,0,0,87.54,207.24Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M80.7,207.34h0a2.2,2.2,0,0,0,2.14-2.24h0a2.19,2.19,0,0,0-2.2-2.18h0a2.21,2.21,0,0,0-2.15,2.24h0A2.21,2.21,0,0,0,80.7,207.34Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M307.87,178.44v0a48.48,48.48,0,0,1,21.58-21.23c31.15-15.61,54.61,9,57.39,13.6,0,0,9.92,9.94,9.84,33.26a47.91,47.91,0,0,1-.51,6.8,50.68,50.68,0,0,1-10.26,1.8l.9-5.95s4-37.32-32.44-42.51c-24.13-3.43-43.74,17.37-43.31,41.5l-.5,3.73-9.63-.17A65.31,65.31,0,0,1,307.87,178.44Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M374,169.15c-5.93-3.84-15.08-8.06-23.11-8.71-10.85-.88-19.38,4.66-25,8.71l-6.9.69a40.24,40.24,0,0,1,13.77-11.15c25.6-12.84,45,6.77,47.94,11.15Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M413.88,197.43a13.85,13.85,0,0,1-9.08,6.66h-8.12v0a76,76,0,0,0-.52-9.17H420C415.54,194.9,413.88,197.43,413.88,197.43Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M396.17,210.87a49.46,49.46,0,0,0,.51-6.78h8.12C404.3,207.54,400.34,209.62,396.17,210.87Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M388.43,172.79h31.41l.36,0a.43.43,0,0,0,0,0,4,4,0,0,1,2.78,2.83c0,14.44-3,19.28-3,19.28H396.16c-1.42-11.68-5.37-18.77-7.65-22Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M388.43,172.79c-.28-.37-.76-1-1.32-1.69l-.27-.29h0c-1.23-1.54-2.63-3.25-2.63-3.25h29.63v0s6.27.45,6.32,5.16l-.36,0Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M22.24,170.67H43.92s-9.09,17.8-5.45,32.05l-6,0c-8.06.09-11.89-7.15-11.89-7.15A65.37,65.37,0,0,1,17.9,185C15.22,170.84,22.24,170.67,22.24,170.67Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M133.68,206.36l-8.61-.15a4,4,0,0,1-1.89-2.52s-1-24.94-18.79-37.86-42-6.37-49.84,7.27c-9.54,16.69-7,26.31-6.53,29.58l-10.58,0c-2.8-8.54,2.53-57.3,47.73-56C131.62,148,133.65,204.5,133.68,206.36Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M83.94,157c-12.47-.35-21.27,3.88-27.39,9.95H51.16c5.73-10.12,16.06-18.87,33.76-18.37,15.93.45,25.56,8.72,31.39,18.37H108.7C102.89,161.33,94.91,157.31,83.94,157Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 291.96,
    y: 115.47,
    width: 16.22,
    height: 22.65,
    rx: 1.35,
    transform: "translate(600.13 253.58) rotate(-180)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M323,124.11l.5-1.15c-29.24-29.68-61.61-51.77-61.93-52,0,0-.73,2,8.64,8.82C272.25,81.25,294,94.6,323,124.11Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M24.36,139h5.41l-.27,10.3H24S24,142.82,24.36,139Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M380.54,151.07c-1.59-6.26,20-5.17,20-5.17l.11,0c7,3.21,12.71,20.06,13.21,21.55l-6.72.06C406.38,167.75,382.13,157.3,380.54,151.07Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M400.52,145.9l.11,0a8.36,8.36,0,0,1,1.55,1c-.95,0-2,.08-3,.15h0l.72,10.17-7.36-.4a53.67,53.67,0,0,0,5.45,3.63h10.23l.48,5.56c1.27.58,2.43,1.09,3.4,1.5l-5,0c-.74.19-25-10.26-26.58-16.49S400.52,145.9,400.52,145.9Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M383.12,149.35a21.66,21.66,0,0,1,7.37-1.51l4.17,12.62S378.37,152.32,383.12,149.35Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M383.74,149.71a17.58,17.58,0,0,1,6-1.22l.45,1.35-4.44.57,4.69.2.62,1.89h-4l4.27.76.63,1.9-3.46-.1,3.77,1.06.85,2.56S379.9,152.11,383.74,149.71Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M380.54,151.07c-1.59-6.26,20-5.17,20-5.17l.11,0c7,3.21,12.71,20.06,13.21,21.55l-6.72.06C406.38,167.75,382.13,157.3,380.54,151.07Z"
  }))), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M399.83,147.34a11.93,11.93,0,0,1,6.76,6.25c2.49,5,0,.31,0,.31s-6-5-21.57-5C385,149,389.69,146.23,399.83,147.34Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M198,201.77l103,1.8a52.51,52.51,0,0,0-.11,5.7l-167.25-2.91A76.19,76.19,0,0,0,133,198l60.75,1.23C194.1,200.53,195.18,201.77,198,201.77Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M396.16,145.22s-32.73-11.31-55.59-15.35c0,0-6.16,3.23-20.77-4.85C319.8,125,309,129.06,396.16,145.22Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M382.54,145.83s-32.69-8.78-61.28-11.26c0,0,2.71,3.2.85,5.08C322.11,139.65,341.19,137.35,382.54,145.83Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M391.35,174.79l27.17-.37s4,.28,3.05,4.25a76.59,76.59,0,0,0-1.37,9.11S422,175.28,391.35,174.79Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M390.68,168.59l20.94-.21s6.1.52,6.1,4C412.55,169.72,409.9,169.63,390.68,168.59Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M314.6,140.2l-8.08.71-105.9-9.83s-5.17,1.08,8.61,2.83S309,142.52,309,142.52,315.07,142.05,314.6,140.2Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M42.06,172H25.12s-6.72-.43-6.72,7.54l2.19,11.7S20.79,172.45,42.06,172Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-47",
    transform: "translate(51.14 104.56) scale(1.1 1)"
  }, "T", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-48",
    x: 8.6,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 19.37,
    y: 0
  }, "\u015F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-50",
    x: 26.95,
    y: 0
  }, "\u0131ma"))), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M149.18,82.64V105.5h.1c.49,0,1,0,1.47,0,.29,0,.4-.12.43-.43.18-1.54.37-3.08.56-4.63.36-3,.69-6,1.1-9a24.35,24.35,0,0,1,.79-3c1,0,2.07.08,3.09.16,2,.15,4,.28,6,.49a11.3,11.3,0,0,1,10.41,7.37,66.77,66.77,0,0,1,3.57,10.4,1,1,0,0,1,0,.59,1.57,1.57,0,0,0,.21,1.58c.07.1.12.23.26.48-.35.36-.69.73-1.05,1.06a.77.77,0,0,1-.47.2c-.76,0-1.52,0-2.28,0a.5.5,0,0,0-.37.29c-.63,2-1.94,3.12-3.64,3.11s-3-1.17-3.56-3.15c0-.08-.05-.15-.08-.24H150.52a5,5,0,0,1-1.34,2.47v6.64h34.2V82.64Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M174.08,107.41c.29,0,.58,0,1,0l-1.45-2.53c-.36-.64-.36-.64-1-.26.42.86.82,1.73,1.25,2.59A.33.33,0,0,0,174.08,107.41Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M150.52,110.83h15.14c0,.09.06.16.08.24.59,2,1.9,3.14,3.56,3.15s3-1.12,3.64-3.11a.5.5,0,0,1,.37-.29c.76,0,1.52,0,2.28,0a.77.77,0,0,0,.47-.2c.36-.33.7-.7,1.05-1.06-.14-.25-.19-.38-.26-.48a1.57,1.57,0,0,1-.21-1.58,1,1,0,0,0,0-.59,66.77,66.77,0,0,0-3.57-10.4,11.3,11.3,0,0,0-10.41-7.37c-2-.21-4-.34-6-.49-1-.08-2.05-.11-3.09-.16a24.35,24.35,0,0,0-.79,3c-.41,3-.74,6-1.1,9-.19,1.55-.38,3.09-.56,4.63,0,.31-.14.44-.43.43-.49,0-1,0-1.47,0h-.1l-1.12,4.84C148.69,109.75,148.92,110.81,150.52,110.83Zm18.84,1.34a2.24,2.24,0,0,1,0-4.45,2.25,2.25,0,0,1,0,4.45Zm-.44-19.42a.56.56,0,0,1,.57,0A11.11,11.11,0,0,1,171.83,96c.62,1.25,1.15,2.55,1.72,3.83,0,.09.06.19.12.36s-.18.3-.3.33a.44.44,0,0,1-.41-.17,6.27,6.27,0,0,1-.37-.88A17.5,17.5,0,0,0,169,93.4C168.81,93.21,168.7,92.94,168.92,92.75Zm-5.65-2.46c0-.17.22-.29.3-.38a12.28,12.28,0,0,1,3.93,1.35c.13.08.16.38.24.58-.18.06-.4.25-.52.18a12.58,12.58,0,0,0-3.57-1.22C163.39,90.74,163.19,90.61,163.27,90.29ZM153.21,96.6l.57-4.68.1-.6c1.31.08,2.59.14,3.86.25.11,0,.25.24.31.4.37,1.06.68,2.15,1.09,3.19a4.26,4.26,0,0,0,2.7,2.62c3.59,1.22,7.15,2.56,10.73,3.83a4.7,4.7,0,0,0,1.41.16.46.46,0,0,1,.51.4c.44,1.55.92,3.08,1.36,4.62a1.18,1.18,0,0,1,0,.67c-.21.61-.32,1.43-.72,1.72s-1.12.1-1.7.11l-.38,0a4.6,4.6,0,0,0-1.35-2.65c-2-1.85-5-.91-5.83,1.88-.13.4-.29.49-.64.48l-9.87-.43a.94.94,0,0,1-.53-.2c-.84-.69-1.67-1.39-2.48-2.12a.94.94,0,0,1-.23-.63C152.46,102.6,152.84,99.6,153.21,96.6Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M154.81,108.35a.94.94,0,0,0,.53.2l9.87.43c.35,0,.51-.08.64-.48.87-2.79,3.82-3.73,5.83-1.88a4.6,4.6,0,0,1,1.35,2.65l.38,0c.58,0,1.29.2,1.7-.11s.51-1.11.72-1.72a1.18,1.18,0,0,0,0-.67c-.44-1.54-.92-3.07-1.36-4.62a.46.46,0,0,0-.51-.4,4.7,4.7,0,0,1-1.41-.16c-3.58-1.27-7.14-2.61-10.73-3.83a4.26,4.26,0,0,1-2.7-2.62c-.41-1-.72-2.13-1.09-3.19-.06-.16-.2-.39-.31-.4-1.27-.11-2.55-.17-3.86-.25l-.1.6-.57,4.68c-.37,3-.75,6-1.11,9a.94.94,0,0,0,.23.63C153.14,107,154,107.66,154.81,108.35Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M169.34,107.72a2.25,2.25,0,1,0,1.93,2.21A2.07,2.07,0,0,0,169.34,107.72Zm0,3.72A1.42,1.42,0,0,1,168,110a1.32,1.32,0,1,1,1.31,1.49Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M172.59,99.46a6.27,6.27,0,0,0,.37.88.44.44,0,0,0,.41.17c.12,0,.21-.23.3-.33s-.08-.27-.12-.36c-.57-1.28-1.1-2.58-1.72-3.83a11.11,11.11,0,0,0-2.34-3.21.56.56,0,0,0-.57,0c-.22.19-.11.46.08.65A17.5,17.5,0,0,1,172.59,99.46Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M163.65,90.8A12.58,12.58,0,0,1,167.22,92c.12.07.34-.12.52-.18-.08-.2-.11-.5-.24-.58a12.28,12.28,0,0,0-3.93-1.35c-.08.09-.26.21-.3.38S163.39,90.74,163.65,90.8Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M169.33,108.46A1.4,1.4,0,0,0,168,110a1.32,1.32,0,1,0,2.61,0A1.39,1.39,0,0,0,169.33,108.46Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 169.85,
    cy: 109.79,
    r: 5.07
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M169.78,105.67a4,4,0,1,0,4,4A4,4,0,0,0,169.78,105.67Zm0,5.76a1.8,1.8,0,1,1,1.8-1.8A1.79,1.79,0,0,1,169.78,111.43Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M175,102.7l1.55,2.72c-.42,0-.73,0-1,0a.44.44,0,0,1-.29-.21c-.45-.92-.89-1.85-1.33-2.78C174.64,102,174.64,102,175,102.7Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M120.51,104.51l-6.06.56h8V107l-12.59.94h12.59v1.81l-15.82,1.09h22.16a.14.14,0,0,1,0-.06h6.67a.14.14,0,0,1,0,.06H140a1,1,0,0,0,.95,1h4.86a1,1,0,0,0,.95-1h5.44v-4.55h0v-1.74Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 131.79,
    cy: 110.06,
    r: 4.54
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 131.86,
    cy: 109.47,
    r: 4.61
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8,105.72a3.61,3.61,0,1,0,3.61,3.61A3.62,3.62,0,0,0,131.8,105.72Zm0,5.24a1.63,1.63,0,1,1,1.63-1.63A1.63,1.63,0,0,1,131.8,111Z"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-52",
    transform: "translate(116.7 104.89) rotate(-5.51) scale(1.1 1)"
  }, "c\u0131m")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAraclar10);
export default __webpack_public_path__ + "static/media/araclar-10.f99e24e328b2c53d3ff546a9032a0491.svg";
export { ForwardRef as ReactComponent };